import React from "react";
import SectionHeader from "../components/SectionHeader";
import { CONSTITUTION_URL, CREST_URL } from "../components/SiteLayout";
import { FileText } from "lucide-react";

const PageHero = ({ overline, title, subtitle }) => (
  <section className="bg-[#0A1F44] text-white section-pad" data-testid="page-hero">
    <div className="max-w-5xl mx-auto px-5 text-center">
      <div className="overline text-[#D4AF37]">{overline}</div>
      <h1 className="font-serif-display font-semibold text-5xl sm:text-6xl mt-4">{title}</h1>
      {subtitle && <p className="mt-6 text-[#D8D3C4] max-w-2xl mx-auto leading-relaxed">{subtitle}</p>}
      <div className="mx-auto mt-8 h-[2px] w-16 bg-[#D4AF37]" />
    </div>
  </section>
);

const AboutPage = () => {
  return (
    <div>
      <PageHero
        overline="About GODSC"
        title="The Gentlemen of Drew."
        subtitle="Founded October 14th, 1982 &mdash; the largest male organization on the campus of Howard University."
      />

      <section className="section-pad">
        <div className="max-w-4xl mx-auto px-5">
          <div className="flex justify-center mb-10">
            <img src={CREST_URL} alt="GODSC Crest" className="h-32 w-auto" />
          </div>
          <SectionHeader
            overline="Our Story"
            title="A legacy built on brotherhood, scholarship, and service."
            align="center"
          />
          <div className="mt-10 text-[#24324F] text-[17px] leading-[1.9] space-y-5 max-w-3xl mx-auto">
            <p>
              Created on Thursday, October 14th, 1982, the vision of our founders
              was to create a bond and alliance, to combat neighborhood violence
              within the surrounding Howard community.
            </p>
            <p>
              Continuing that legacy, GODSC has evolved into a premier organization
              for men on the campus of Howard University, with the focus on
              scholastic success, leadership, and serving our community.
            </p>
            <p>
              As the <strong>largest male organization on campus</strong>, The
              Gentlemen of Drew Social Club continuously seeks opportunities to
              mentor young males, to promote higher education and the importance
              of carrying on the legacy of the many Black leaders and achievers
              that have paved the road less traveled and the pathway to success.
            </p>
            <p className="text-[#0A1F44] font-medium pt-2">
              GODSC is open to all first-year male students at Howard University.
            </p>
          </div>

          <div className="flex justify-center mt-12">
            <a
              href={CONSTITUTION_URL}
              target="_blank"
              rel="noreferrer"
              className="inline-flex items-center gap-3 px-5 py-3 border border-[#0A1F44] text-[#0A1F44] hover:bg-[#0A1F44] hover:text-[#D4AF37] transition-colors"
              data-testid="about-constitution-link"
            >
              <FileText size={16} />
              <span className="overline">Read the GODSC Constitution (2017)</span>
            </a>
          </div>
        </div>
      </section>

      <section className="bg-[#F5F1E6] section-pad">
        <div className="max-w-7xl mx-auto px-5">
          <SectionHeader
            overline="What We Value"
            title="Brotherhood. Scholarship. Service."
            align="center"
          />
          <div className="mt-14 grid md:grid-cols-3 gap-8">
            {[
              {
                title: "Brotherhood",
                text:
                  "A disciplined bond among first-year men who choose accountability over comfort &mdash; and who never walk their Howard journey alone.",
              },
              {
                title: "Scholarship",
                text:
                  "The pursuit of scholastic success is our foundation. We mentor, study together, and push one another toward academic excellence.",
              },
              {
                title: "Service",
                text:
                  "We serve Howard, the District, and the culture &mdash; because what we inherit, we expand, and what we gain, we return.",
              },
            ].map((v) => (
              <div key={v.title} className="bg-white p-10 border border-[#D8D3C4]">
                <div className="h-[2px] w-10 bg-[#D4AF37] mb-5" />
                <h3 className="font-serif-display text-3xl text-[#0A1F44] mb-3">{v.title}</h3>
                <p
                  className="text-[#5C5C5C] text-[15px] leading-relaxed"
                  dangerouslySetInnerHTML={{ __html: v.text }}
                />
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export { PageHero };
export default AboutPage;
